<template>
    <div class="page-container">

        <el-card class="box-card">
            <el-form :inline="true" :model="queryParams" class="demo-form-inline">
                <el-form-item label="部门名称">
                    <el-input clearable v-model="queryParams.name" placeholder="请输入部门名称"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button icon="el-icon-search" type="primary" @click="handleQuery">查询</el-button>
                    <el-button icon="el-icon-refresh" @click="handleReset">重置</el-button>
                </el-form-item>
            </el-form>
        </el-card>
        <div style="height: 10px;"></div>

        <el-card class="box-card">
            <el-button :disabled="tableData.length!==0" type="success" icon="el-icon-plus" @click="handleAdd(null)" size="mini" plain>新增</el-button>
            <div style="height: 10px;"></div>

            <el-table border
                      :default-expand-all="isExpandAll"
                      :data="tableData"
                      row-key="id"
                      :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
                <!-- 部门名称 -->
                <el-table-column prop="name" label="部门名称" align="center"></el-table-column>
                <!-- 排序 -->
                <el-table-column prop="sort" label="排序"></el-table-column>
                <el-table-column prop="createTime" label="创建时间" align="center">
                    <template slot-scope="scope">
                        <span>{{ scope.row.createTime | dateFilter }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                        <el-button size="small" icon="el-icon-plus" @click="handleAdd(scope.row)" v-if="scope.row.pid === 0">新增
                        </el-button>
                        <el-button size="small" type="info" @click="handleUpdate(scope.row)">修改</el-button>
                        <el-button v-if="scope.row.pid!==0" size="small" type="danger" @click="handleDelete(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>

        </el-card>

        <!-- 部门信息对话框 -->
        <el-dialog
            :title="menuTitle"
            width="620px"
            :modal-append-to-body="true"
            :append-to-body="true"
            :close-on-click-modal="false"
            :visible="menuVisible"
            :before-close="handleClose">
            <div class="menu-wrapper">
                <el-form ref="menuForm" :model="formData" :rules="rules" label-width="100px" label-position="right" size="small">
                    <el-row :gutter="20" class="form-row">
                        <el-col :span="24">
                            <el-form-item label="上级部门" prop="pid">
                                <el-select style="width: 100%;" v-model="formData.pid" placeholder="选择上级部门" clearable>
                                    <el-option v-for="item in searchData" :key="item.value" :label="item.name" :value="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="部门名称" prop="name">
                                <el-input v-model="formData.name" placeholder="请输入部门名称"/>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="显示排序" prop="sort">
                                <el-input-number v-model="formData.sort" controls-position="right" :min="0"/>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
            <div slot="footer">
                <el-button type="danger" :loading="buttonLoading" @click="handleClose()" size="small" icon="el-icon-error">
                    取消
                </el-button>
                <el-button type="success" :loading="buttonLoading" @click="submitForm()" size="small" icon="el-icon-success">
                    保存
                </el-button>
            </div>
        </el-dialog>

    </div>
</template>
<script>
import {reqDeleteDeptById, reqInsertDept, reqListDept, reqUpdateDept} from "../../../api/core/Dept";
import {reqDeleteAddressById} from "../../../api/core/Address";

export default {
    name: 'Dept',
    data() {
        return {
            // 高级搜索 展开/关闭
            advanced: false,
            // 数据总条数
            total: 0,
            // 部门对话框是否显示
            menuVisible: false,
            // 数据表格等待框
            loading: false,
            // 查询参数
            queryParams: {
                // 部门名称
                name: undefined,
                // 部门状态
                status: undefined,
                // 时间范围
                dataRange: []
            },
            // 是否展开，默认全部折叠
            isExpandAll: true,
            // 重新渲染表格状态
            refreshTable: true,
            // 部门表单对象
            formData: {
                // 部门ID
                id: undefined,
                // 部门名称
                name: undefined,
                // 父部门
                pid: undefined,
                // 访问路径
                path: undefined,
                // 部门类型
                type: 'D',
                // 激活部门
                activeMenu: undefined,
                // 组件路径
                component: undefined,
                // 是否缓存
                isCache: false,
                // 是否外链
                isLink: false,
                // 是否隐藏
                visible: false,
                // 图标
                icon: undefined,
                // 排序
                sort: 0,
                // 部门状态
                status: true
            },
            // 部门表单校验规则
            rules: {
                // 部门名称
                name: [{required: true, message: '部门名称不能为空', trigger: 'blur'}],
                // 排序
                sort: [{required: true, message: '部门顺序不能为空', trigger: 'blur'}],
                // 访问路径
                path: [{required: true, message: '路由地址不能为空', trigger: 'blur'}]
            },
            // 部门对话框等待框
            menuLoading: false,
            // 对话框按钮等待框
            buttonLoading: false,
            // 表格数据
            tableData: [],
            // 对话框标题
            menuTitle: '',
            // 部门选项
            menuOptions: [],
            searchData: [],
            caterDialogVisible: false,
            caterParams: {
                id: undefined,
                name:null,
                businessType: 1,
                maxCount: 1
            }
        }
    },

    created() {
        // 查询表格数据
        this.getTableData()
    },

    methods: {
        // 获取表格数据
        async getTableData() {
            // 开启加载框
            this.loading = true
            this.tableData = [];
            let data = await reqListDept(this.queryParams);
            this.tableData = data;
            this.searchData = JSON.parse(JSON.stringify(data))
            // 确保加载框可以关闭
            this.loading = false
        },
        toggleAdvanced() {
            this.advanced = !this.advanced
        },
        // 展开/折叠
        toggleExpandAll() {
            this.refreshTable = false
            this.isExpandAll = !this.isExpandAll
            this.$nextTick(() => {
                this.refreshTable = true
            })
        },
        // 点击查询按钮
        handleQuery() {
            this.queryParams.currentPage = 1
            this.getTableData()
        },
        // 点击重置按钮
        handleReset() {
            this.queryParams = {
                // 部门名称
                name: undefined,
                // 部门状态
                status: undefined,
                // 时间范围
                dataRange: []
            }
        },
        // 打开部门信息对话框
        handleOpen() {
            // 清除表单数据
            this.reset()
            this.menuVisible = true
        },
        closeCaterDialog() {
            this.caterDialogVisible = false;
        },
        // 关闭部门对话框表单
        handleClose() {
            this.reset()
            this.menuVisible = false
        },
        // 点击新增按钮
        handleAdd(row) {
            this.menuTitle = '新增部门'
            this.handleOpen()
            if (row) {
                this.formData.pid = row.id
            }
        },
        handlerConfig(row) {
            this.caterParams.id = row.id;
            this.caterParams.name = row.name;
            this.caterParams.businessType = row.businessType;
            this.caterParams.maxCount = row.maxCount;
            debugger
            this.caterDialogVisible = true;
        },
        // 点击编辑按钮
        handleUpdate(row) {
            // 修改对话框标题
            this.menuTitle = '更新部门'
            this.formData = JSON.parse(JSON.stringify(row))
            // 打开编辑部门对话框
            this.menuVisible = true
            // 关闭加载框
            this.menuLoading = false
        },
        // 点击删除事件
        async handleDelete(row) {
            this.$confirm('是否确认删除选中的部门数据？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                await reqDeleteDeptById({id: row.id});
                this.$message.success('删除成功')
                // 刷新数据
                await this.getTableData()
            })
        },
        async btnDelete(id) {
            this.$confirm('确定要删除吗?', '信息', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                await reqDeleteAddressById({id: id});
                this.$message.success("操作成功");
                this.query.current = 1
                await this.load();
            });
        },
        // 提交表单
        async submitForm() {
            const that = this

            const valid = await this.$refs.menuForm.validate();
            if (!valid) {
                return;
            }
            if (this.formData.id) {
                await reqUpdateDept(this.formData);
            } else {
                await reqInsertDept(this.formData);
            }
            this.$message.success('操作成功')
            // 刷新表单数据并关闭对话框
            that.handleClose()
            // 刷新部门数据
            await that.getTableData()
        },
        async submitRoleForm2() {
            if (!this.caterParams.businessType) {
                this.$message.error("请选择可点餐配置！");
                return;
            }
            await reqUpdateDept(this.caterParams);
            this.$message.success("可点餐配置成功");
            this.closeCaterDialog();
            await this.load();
        },
        // 重置表单
        reset() {
            // 清除校验条件
            this.formData = {
                // 部门ID
                id: undefined,
                // 部门名称
                name: undefined,
                // 父部门
                pid: 0,
            }
            // 清除表单校验规则
            this.resetForm('menuForm')
        },
        // 选择图标
        selectIcon(name) {
            this.formData.icon = name
        }
    }
}

</script>

<style lang="scss" scoped>
.menu-wrapper {
    padding: 10px 30px;
}

.form-row {
    display: flex;
    flex-wrap: wrap;
}

</style>
